import React, { useEffect, useState } from "react";
import { Card, Col, Form, Row, Button, Table } from "react-bootstrap";
import schoolApi from "../../api/schoolApi";
import ScrollLazyLoader from "../common/ScrollLazyLoader";
import { Link, useLocation } from "react-router-dom";
import jsPDF from "jspdf";
import PdfHeader from "../layout/common/PdfHeader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import { Helmet } from "react-helmet";
import {
  Filter,
  DatatableWrapper,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import InfoPill from "../InfoPill";
import "./reportsDetails.css";
import jwt_decode from "jwt-decode";
import { useContext } from "react";
import { SessionContext } from "../SessionProvider";


const DueFeeReport = (props) => {
  const location = useLocation();
  
  const { selectedSessionId } = useContext(SessionContext);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  const [classOptions, setClassOptions] = useState([]);
  const [sessionOptions, setSessionOptions] = useState([]);
  const [reportData, setReportData] = useState({
    classid: "",
    session_id: "",
  });
  let [feeData, setFeeData] = useState([]);
  const totalPages = Math.ceil(feeData?.length / rowsPerPage);

  const [settings, setSettings] = useState({});
  const [netAmount, setNetAmount] = useState({
    total_amount: 0,
    total_due_fees: 0,
    total_others_amount: 0,
  });
  const [userInfo, setUserInfo] = useState({});
  




  useEffect(() => {
    fetchClassRecords();
    fetchAllSessions();
  }, []);

  useEffect(() => {
    if (selectedSessionId) {
      setReportData((prevState) => ({
        ...prevState,
        session_id: selectedSessionId,
      }));
    }
  }, [selectedSessionId]);

    useEffect(() => {
      try {
        if (sessionStorage.getItem("token")) {
          let user = jwt_decode(sessionStorage.getItem("token"));
          setUserInfo(user);
        }
      } catch (error) {
       
      }
    }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (location.state && location.pathname === "/duefeereport") {
       

        await fetchAllSessions();

        if (settings && settings.frequency && settings.late_fee) {
          fetchDueFeesData();
        } else {

        }
      }
    };

    fetchData();
  }, [location.pathname, location.state]);

  useEffect(() => {
    if (location.state && location.pathname === "/duefeereport") {
      if (settings && settings.frequency && settings.late_fee) {
        fetchDueFeesData();
      }
    }
  }, [settings]);


  const fetchDueFeesData = async () => {
    try {
      const result = await schoolApi.fetchDueFees(
        location.state.classid,
        location.state.session_id
      );

      if (result.success) {
        if (settings && settings.frequency && settings.late_fee) {
          filterData(result.result);
        } else {

        }
      } else {
        return toast.error(result.message);
      }
    } catch (error) {
      console.error("Error fetching due fees:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (location.state && location.pathname === "/duefeereport") {
       
        await fetchAllSessions();
        fetchDueFeesData();
      }
    };

    fetchData();
  }, [location.pathname, location.state]);

  const fetchClassRecords = async () => {
    try {
      const result = await schoolApi.getActiveClassRecords();
      if (result.success) {
        const options = result.result.map((item) => ({
          value: item.id,
          label: item.classname,
        }));
        setClassOptions(options);
      }
    } catch (error) {
      console.error("Error fetching class records:", error);
    }
  };

  const fetchAllSessions = async () => {
    try {
      const ResultSettings = await schoolApi.getAllSetting();
     
      if (ResultSettings.success) {
        setSettings({
          frequency: ResultSettings.data.find((res) => res.key === "frequency")
            .value,
          late_fee: ResultSettings.data.find((res) => res.key === "late_fee")
            .value,
        });
      }

      const sessions = await schoolApi.fetchSessions();
      if (sessions.success) {
        const options = sessions?.result?.map((sess) => ({
          value: sess.id,
          label: sess.year,
        }));
        setSessionOptions(options);

        const today = new Date().toISOString().split("T")[0];
        const currentSession = sessions?.result?.find((sess) => {
          const startDate = sess.startdate ? sess.startdate.split("T")[0] : "";
          const endDate = sess.enddate ? sess.enddate.split("T")[0] : "";
          return today >= startDate && today <= endDate;
        });

        const selectedSessionIdToUse = location.state?.session_id || selectedSessionId || currentSession?.id;

        if (selectedSessionIdToUse) {
          setReportData((prevState) => ({
            ...prevState,
            session_id: selectedSessionIdToUse,
            classid: location.state?.classid || prevState.classid,
          }));
        }
      }
    } catch (error) {
      console.error("Error fetching sessions:", error);
    }
  };
 

  const handleChange = (event) => {
    const { name, value } = event.target;
    setReportData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSearch = async () => {
    if (reportData.session_id) {
      try {
        const result = await schoolApi.fetchDueFees(
          reportData.classid,
          reportData.session_id
        );
        if (result.success) {
          filterData(result.result);
        } else {
          return toast.error(result.message);
        }
      } catch (error) {
        console.error("Error fetching due fees:", error);
      }
    } else {
      setFeeData([]);
      return toast.error("Please select required fields!!");
    }
  };

  const currentDate = new Date().toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
    const handleDownload = () => {
      const doc = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a4",
      });
  
      const renderPdfHeader = (doc) => {
        const logoUrl = `/${userInfo?.tenantcode}-sidebar-logo.png`;
        doc.addImage(logoUrl, "PNG", 14, 10, 27, 27);
        doc.setFontSize(18);
        doc.text(userInfo?.companyname || "Company Name", 145, 20, {
          align: "center",
        });
        doc.setFontSize(10);
        const address = `${userInfo?.companystreet}, ${userInfo?.companystate}-${userInfo?.companypincode}, ${userInfo?.companycountry}`;
        const addressLines = doc.splitTextToSize(address, 180);
        doc.text(addressLines, 145, 26, { align: "center" });
        doc.setFontSize(12);
        doc.text(`Date: ${currentDate}`, 280, 20, { align: "right" });
  
        doc.line(14, 40, 283, 40);
        doc.text("Fee Due Report", 125, 47);
      };
  
      renderPdfHeader(doc);
  
      const tableData = feeData.map((row, index) => [
        index + 1,
        row?.student_name,
        row?.class + "" + (row.section_name ? `(${row.section_name})` : ""),
        row?.due_amount,
        row?.others,
        row?.total_amount,
        row?.due_date,
        row?.status,
      ]);
      const lastIndex = feeData.length;

      const footerRow = [
        { content: "Total", colSpan: 3, styles: { halign: "right",fillColor: [240, 240, 240],textColor: [33,37,71],fontStyle: "normal",} },
        { content: dueAmount, styles: { halign: "right",fillColor: [240, 240, 240],textColor: [33,37,71],fontStyle: "normal", } },
        { content: othersAmount, styles: { halign: "right",fillColor: [240, 240, 240],textColor: [33,37,71],fontStyle: "normal",} },
        { content: totalAmount, styles: { halign: "right",fillColor: [240, 240, 240],textColor: [33,37,71],fontStyle: "normal", } },
        { content: "", styles: { halign: "right",fillColor: [240, 240, 240],textColor: [33,37,71],} },
        { content: "", styles: { halign: "right",fillColor: [240, 240, 240],textColor: [33,37,71],} },
      ];
      tableData.push(footerRow)
      doc.autoTable({
        head: [
          [
            "Sr No.",
            "Student Name",
            "Class",
            "Due Fees",
            "Others",
            "Total Amount",
            "Due Date",
            "Status",
          ],
        ],
        body: tableData,

        didDrawCell: (data) => {
          doc.setLineDash([1, 1], 0);
        },
  
        styles: {
          borderTop: "2px solid #000",
          margin: "10px 0",
          border: 1, // General border setting for all cells
          lineWidth: 0.1, // Border thickness
          lineColor: [0, 0, 0], // Border color (Black)
          fontSize: 10,
        },
        headStyles: {
          fillColor: "rgb(41,56,70)", // Background color (RGB: Blue)
          textColor: [255, 255, 255], // Text color (White)
          halign: "center", // Center-align header text
          fontStyle: "bold", // Make text bold
        },
        columnStyles: {
          0: { halign: "right",cellWidth: 14 },
          3: { halign: "right" },
          4: { halign: "right" },
          5: { halign: "right" },
          6: { halign: "right" },
        },
        margin: { top: 50 },
      });
  
      doc.save("FeeDuesReports.pdf");
    };

  const filterData = (result) => {
   
    let data = [];
    let total_due_fees = 0;
    let total_others_amount = 0;
    let total_amount = 0;

    result?.forEach((item) => {
      let due_amount = 0;
      let others = 0;
      let student_total_amount = 0;
      const currentDate = moment();

      item?.installments?.forEach((inst) => {
       
        if (
          inst.status === "pending" &&
          moment(inst.due_date).isSameOrBefore(currentDate)
        ) {
         
          due_amount += inst.installmentamount;
          const daysOverdue = currentDate.diff(moment(inst.due_date), "days");
         
         
         
          const lateFee =
            Math.round(
              (daysOverdue + parseInt(settings.frequency)) /
                parseInt(settings.frequency)
            ) * parseInt(settings.late_fee);
         
          others += lateFee;
         

         
         
        }
      });

      student_total_amount = due_amount + others;

      if (due_amount > 0) {
        data.push({
          student_name: item.student_name,
          class: item.classname,
          section_name: item.section_name,
          due_amount: due_amount,
          others: others,
          total_amount: student_total_amount,
          due_date: item.installments[0]?.due_date,
          status: due_amount > 0 ? "Overdue" : "Pending",
        });

        total_due_fees += due_amount;
       
       
        total_others_amount += others;
       
        total_amount += student_total_amount;
       
      }
    });

    setFeeData(data);
    setNetAmount({
      total_amount: total_amount,
      total_due_fees: total_due_fees,
      total_others_amount: total_others_amount,
    });


    if (data.length === 0) {
      toast.error("No Record Found");
    }
  };
  const formatNumberWithCommas = (number) => {
    return number ? number.toLocaleString("en-IN") : "0";
  };

  feeData = feeData
  ? feeData.map((fee, index) => ({
      ...fee,
      serialNumber: index + 1,
    }))
  : [];
  let totalAmount = 0;
  let dueAmount = 0;
  let othersAmount = 0;


  feeData.forEach((item) => {
   
    if (item.total_amount) {
      totalAmount += item.total_amount; // Add the `total_amount` field to `totalAmount`
    }
    if (item.due_amount) {
      dueAmount += item.due_amount; // Add the `total_amount` field to `totalAmount`
    }
    if (item.others) {
      othersAmount += item.others; // Add the `total_amount` field to `totalAmount`
    }
  });

  const Footer = [
    <tr>
      <td style={{ textAlign: "right" }} colSpan={3} className="text-right font-weight-bold">
        Total
      </td>
      <td style={{ textAlign: "right" }} className="font-weight-bold">
        {dueAmount}
      </td>
      <td style={{ textAlign: "right" }} className="font-weight-bold">
        {othersAmount}
      </td>
      <td style={{ textAlign: "right" }} className="font-weight-bold">
        {totalAmount}
      </td>
      <td style={{ textAlign: "right" }} className="font-weight-bold"></td>
      <td style={{ textAlign: "right" }} className="font-weight-bold"></td>
    </tr>
  ];
  
 
 
 
  

  const headers = [
    {
      title: "Sr. No.",
      prop: "",
      width: "50px",
      cell: (row) => (
        <div style={{ textAlign: "right" }}>
          {row.serialNumber}
        </div>
      ),
    },

    {
      title: "Student Name",
      prop: "student_name",
      isFilterable: true,

    },
    {
      title: "Class",
      prop: "class",
      isFilterable: true,
      cell: (row) => `${row.class} [${row.section_name}]`,
    },
    {
      title: "Due Fees",
      prop: "due_amount",
      isFilterable: true,
      cell: (row) => (
        <div style={{ textAlign: "right" }}>
          {row.due_amount}
        </div>
      ),
    },
    { title: "Others", prop: "others", isFilterable: true,
      cell: (row) => (
        <div style={{ textAlign: "right" }}>
          {row.others}
        </div>
      ),
     },
    {
      title: "Total Amount",
      prop: "total_amount",
      cell: (row) => (
        <div style={{ textAlign: "right" }}>
          {row.total_amount}
        </div>
      ),
    },
    {
      title: "Due Date",
      prop: "due_date",
      isFilterable: true,
      cell: (row) => (
        <div style={{ textAlign: "right" }}>
          {row.due_date}
        </div>
      ),
    },

    { title: "Status", prop: "status",
      cell: (row) => (
        <div style={{ textAlign: "left" }}>
          {row.status}
        </div>
      ),
    },
  ];

  const labels = {
    beforeSelect: " ",
  };

  return (
    <>
      <Helmet>
        <title>{props?.tabName}</title>
      </Helmet>
      <Row className="g-0">
        <Col lg={3} className="mx-3">
          <Link className="nav-link mx-2" to="/">
            Home <i className="fa-solid fa-chevron-right"></i> Fees Dues Report
          </Link>
        </Col>
      </Row>
      <Row className="mt-5 m-0 px-4">
        <Card className="px-0 py-3" style={{ marginTop: "-18px" }}>
          <Row className="m-0">
            <Col lg={12} className="px-3">
              <h5 className="fw-semibold">Filters</h5>
            </Col>
            <hr />
          </Row>
          <Row className="flex-row mt-3 mb-2 px-4">
            <Col lg={4}>
              <Form.Group className="mx-3">
                <Form.Label className="form-view-label">Class Name</Form.Label>
                <Form.Select
                  name="classid"
                  onChange={handleChange}
                  value={reportData.classid}
                >
                  <option key="default" value="">
                    All
                  </option>
                  {classOptions.map((res) => (
                    <option key={res.value} value={res.value}>
                      {res.label}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col lg={4}>
              <Form.Group className="mx-3">
                <Form.Label className="form-view-label">Session</Form.Label>
                <Form.Select
                  name="session_id"
                  onChange={handleChange}
                  value={reportData.session_id}
                  required
                >
                  <option value="">-- Select Session --</option>
                  {sessionOptions.map((res) => (
                    <option key={res.value} value={res.value}>
                      {res.label}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            <Col lg={4} className="d-flex align-items-end">
              <div className="button-wrapper">
                <Button onClick={handleSearch} variant="primary">
                  Search
                </Button>
                {feeData.length > 0 && (
                  <Button
                    onClick={handleDownload}
                    variant="primary"
                    className="ms-3"
                  >
                    Download
                  </Button>
                )}
              </div>
            </Col>
          </Row>
        </Card>
      </Row>
      {feeData.length > 0 && (
        <Row className="mt-5 m-0 px-4">
          <Card className="px-0 py-3">
            <Row className="flex-row mb-3 px-4">
              <Col lg={12} className="p-0">
          <Row className="mt-5 m-0 px-4">
                <div id="reportContent">
                  <PdfHeader />
                  <div
                    style={{ borderTop: "2px solid #000", margin: "10px 0" }}
                  ></div>
                  <Row className="mt-2">
                    <Col lg={12} className="px-3">
                      <h5
                        style={{ textAlign: "center" }}
                        className="fw-semibold"
                      >
                        Fee Dues Report
                      </h5>
                    </Col>
                  </Row>
                </div>
                <Col lg={12} className="mt-1 px-1">
                  <DatatableWrapper
                    headers={headers}
                    body={feeData}
                    paginationOptionsProps={{
                      initialState: {
                        rowsPerPage: 50,
                        options: [50, 100, 200, 500, 1000],
                      },
                    }}
                  >
                    <ScrollLazyLoader maxRows={1000} step={50} />
                    <Row className="mb-4">
                      <Col
                        lg={3}
                        sm={4}
                        className="d-flex flex-col justify-content-end align-items-end"
                      >
                      <Filter />  
                      </Col>
                      <Col
                        xs={12}
                        sm={6}
                        lg={5}
                        className="d-flex flex-col justify-content-start align-items-start"
                      >
                        <PaginationOptions labels={labels} />
                        <div className="mt-2">
                          <InfoPill
                            left="Total Students"
                            right={feeData?.length}
                          />
                        </div>
                      </Col>
                      <Col
                        xs={12}
                        sm={6}
                        lg={4}
                        className="d-flex flex-col justify-content-end align-items-end"
                      ></Col>
                    </Row>
                    <Table
                      striped
                      className="transaction-report-table"
                      responsive
                      id="inventory-table-details"
                    >
                      <TableHeader />
                      {feeData?.length > 0 ? (
                        <>
                        <TableBody />
                        {Footer}
                      
                      </>
                      ) : (
                        <TableBody>
                          <tr>
                            <td colSpan={7} className="text-center">
                              No records found
                            </td>
                          </tr>
                        </TableBody>
                      )}
                    </Table>
                    <Pagination />
                  </DatatableWrapper>
                </Col>
              </Row>
                
              </Col>
            </Row>
          </Card>
        </Row>
      )}
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      ;
    </>
  );
};

export default DueFeeReport;